import Vue from 'vue';
import Router from 'vue-router';
import Index from './components/index/Index';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/menyu',
      name: 'Menu',
      component: Index,
      children: [
        {
          path: ':type',
          name: 'MenuNested',
          component: Index
        }
      ]
    },

    {
        path: '/fotootchyoty/:type',
        name: 'PhotoReport',
        component: Index,
    },

    {
        path: '/anonsy/:type',
        name: 'Announcement',
        component: Index,
    },

    {
      path: '/korzina',
      name: 'Cart',
      component: Index,
      children: [
        {
          path: ':step',
          component: Index,
          name: 'CartStep'
        }
      ]
    },

    {
      path: '*',
      name: 'Index',
      component: Index
    },
  ],
})
